/*
 * @Description: 接口文件
 * @Autor: txp
 * @Date: 2021-03-29 19:57:27
 */
import request from "@/utils/request";
// 获取数字字典
export const mdmdictdata = (data) =>request.post('/mdm/mdmdictdata/list',data);
//获取多个数据字典
export const mdmdictdatas = (data) =>request.post('/mdm/mdmdictdata/batchDictSelect',data);
// =======登录模块
// 1.登录接口
export const Login =(data)=> request.post('/mdm/mdmDmsMallLoginController/login',data);
// 2.退出登录
export const LoginOut = (data) =>request.post('/mdm/mdmDmsMallLoginController/logout',data)
// =======订单模块
// 1.我的订单接口
export const Myorder = (data) =>request.post('/order/hdOrderController/listByConditions',data)
//2、订单详情
export const orderDetail = (data) =>request.get(`/order/m/order/findSimpleDetailsById/${data}`)
// 3、作废订单
export const orderCancel = (data) =>request.get(`/order/hdOrderController/cancel/${data}`)
// =======首页模块
// 1.获取菜单栏
export const ProductLevelTree =(data) =>request.post('/mdm/baseTreeController/productLevelTree',data)
// 2.获取商品列表
export const HomeList =(data) =>request.post('/mdm/p/cus/availableList/list',data)
// 获取列表详情，进入购物车get请求直接添加数据
export const FindGoodsDetailAndPromotionByCode = (data)=> request.get(`/mdm/p/cus/availableList/findGoodsDetailAndPromotionByCode/${data}`)
// ======资金费用模块
// 1. 资金情况接口  
export const getDealerBalance = (data) =>request.get('/dms/dmsHdDealerBalanceController/getSapBalance',data)
// 2.折扣情况接口
export const discountDetail = (data) =>request.get('/fee/feePoolProController/queryDiscountMonthAmountByCustomerCode',data)
// 3.货补情况接口
export const gooddsDetail = (data) =>request.get('/fee/feePoolProController/queryGoodsMonthAmountByCustomerCode',data)
// 4.公告列表
export const HomenoticeList = (data)=>request.post('/dms/p/notice/list',data)  
// 5.公告，通过id查询公告
export const HomereadNotice = (data)=>request.get(`/dms/v/notice/findById/${data}`)  
// 6.阅读公告（如果已经阅读则不用调用此接口,直接传递获取的值）
export const ReadNotice = (data)=>request.post('/dms/p/notice/readNotice',data)
// 7.首页列表轮播
export const HomerotationpicList = (data)=>request.get('/dms/p/rotationpic/list',data)  
// 8.点击收藏
export const OfenByfictitiousIds = (data)=>request.post('/mdm/p/cus/availableList/ofenByfictitiousIds',data)
// 9.取消收藏
export const reMoveOfenByfictitiousIds = (data) =>request.post('/mdm/p/cus/availableList/reMoveOfenByfictitiousIds',data)
//======客户互动模块
// 9.公司资料查看
export const CompanyDataView = (data) => request.post('/dms/p/companyInformation/list',data)
// 10.加入购物车
export const ShoppingCart = (data) =>request.post('/mdm/p/shoppingcart/add',data)
// 11.购物车列表
export const ShoppingcartList = (data) =>request.post('/mdm/hdbqShoppingCartController/list',data)
// 12.删除购物车产品
export const delByIds = (data) =>request.post('/mdm/p/shoppingcart/delByIds',data)
// 1.修改密码
export const ChangePassword = (data) =>request.post('/mdm/mdmUserController/changePassword',data)
//2.合同管理
export const ContractManager = (data) => request.post('/dms/p/saleContract/findContractPageByConditions',data)
//3.合同管理下拉框查询
export const QueryContract = (data) => request.post('/mdm/mdmdictdata/list',data)
// 4.合同管理详情
export const FindContractDetailByCode = (data) => request.get(`/dms/m/saleContract/findContractDetailByCode?code=${data}`)
// 5.合同管理基础信息详情 
export const mdmtableconfigForm = (data) => request.post('/mdm/mdmtableconfig/form/query',data)
// 6.合同省市区查看
export const mdmRegionController = (data)=>request.post('/mdm/mdmRegionController/select',data)
// 7.确定签订合同
export const SaleContractSign = (data) =>request.post('/dms/p/saleContract/sign',data)
// ======费用池
// 1.折扣费用池 资金上账明细
export const getSearchAddList = (data) =>request.post('/dms/dmsHdDealerCapitalDetailController/searchAddList',data)
// 2.折扣费用池 资金使用明细
export const getSearchUseList = (data) =>request.post('/dms/dmsHdDealerCapitalDetailController/searchUseList',data)
// 3.折扣费用池 折扣上账
export const discountUpList = (data) =>request.post('/fee/feePoolDiscountController/findFeePoolDetailAccountList',data)
// 4.折扣费用池 折扣使用
export const discountUseList = (data) =>request.post('/fee/feePoolDiscountController/findFeePoolUseList',data)
// 5.货补明细查询 货补上账
export const goodsUpDetail = (data) => request.post('/fee/feePoolGoodsController/findFeePoolDetailAccountList',data)
// 6.货补明细查询 货补使用
export const goodsUseDetail = (data) => request.post('/fee/feePoolGoodsController/findFeePoolUseList',data)
// 表格导入导出
export const RepeatedWriteExport = (data)=>request.post('/excel/excelController/repeatedWriteExport',data)
// 任务查询 销量目标
export const getList = (data) => request.post('/dms/p/saleGoal/list',data)
// 任务查询详情
export const taskDetail = (data) => request.get(`/dms/m/saleGoal/findById/${data}`)
// 结算订单模块
// 1.获取收货地址
export const ListCondition = (data) =>request.post('/mdm/mdmCustomerAddressController/listCondition',data)
// 2.常购
export const AvailableList = (data)=>request.post('/mdm/p/cus/availableList/list',data)
// 3.货补
export const FindFeePoolGoodsProductGroupList = (data)=>request.post('/fee/feePoolGoodsController/findFeePoolGoodsProductGroupList',data)
// 4.折扣可用余额
export const QueryDiscountAmountByCustomerCode = (data)=>request.get(`/fee/feePoolDiscountController/queryDiscountAmountByCustomerCode?customerCode=${data}`)
// 促销政策
export const LoadPromotionPolicyConfigInfoForOrder = (data)=>request.post("/dms/promotion/policy/loadPromotionPolicyConfigInfoForOrder",data)
// 订单结算信息，金额计算
export const OrderCal = (data)=>request.post("/order/m/order/cal",data)
// 我的订单处，暂存订单去下单
export const FindDetailsById = (data)=>request.get(`/order/m/order/findDetailsById/${data}`)
// 查询列表配置
export const getTableConfig = (data)=>request.post("/mdm/mdmtableconfig/query",data)
// 查询政策列表
export const getPromotionList = (data)=>request.post("/dms/promotion/v2/findAvailablePromotionsByAccount",data)
// 获取数据字典
export const getBatchDictSelect = (data)=>request.post("/mdm/mdmdictdata/batchDictSelect",data)
//订单算价
export const getOrderCal = (data)=>request.post("/order/m/order/cal",data)
//订单汇总
export const getOrderCollect = (data)=>request.post("/order/m/order/collect",data)
//查询可用折扣
export const queryPoolAmount = (data)=>request.post("/fee/feePoolController/queryPoolAmount",data)
// 保存订单
export const orderAdd = (data,option)=>request.post("/order/m/order/add",data,option)
// 暂存订单
export const orderTemporary = (data)=>request.post("/order/m/order/temporary/add",data)
// 编辑订单
export const orderEdit = (data, option)=>request.post("/order/m/order/edit",data, option)
//收货 
export const confirmReceipt = (data)=>request.post('/order/dmsHdDeliverGoodsController/confirmReceipt',data)
//发货列表
export const deliverList = (data)=>request.post('/order/dmsHdDeliverGoodsController/list',data);
//发货明细 
export const deliverGoodsList = (data)=>request.post('/order/dmsHdDeliverGoodsController/findDetailList',data)
//待收货列表 
export const getReceivingList = (data)=>request.post('/order/dmsHdDeliverGoodsController/getReceivingList', data)
// 添加返利项商品
export const rebateGoodsList = (data)=>request.post('/mdm/hdAvailableList/list',data)
// 最低价校验
export const checkPrice = (data)=> request.post('/order/hdOrderController/verificationMinPrice',data)
// 获取我的发货单数据
export const mydeliveryOrder = (data)=> request.post('/order/dmsHdDeliverGoodsController/pageList',data)
//删除发货单
export const delTemporaryOrder = (data)=>request.post('/order/hdOrderController/delTemporaryOrder',data)

//获取告知函
export const findPageByConditions = (data)=>request.post('/order/inform/findPageByConditionsCurrentCus',data)
//获取告知函
export const notifyFindById = (data)=>request.get(`/order/inform/findById/${data}`)
//发送验证码
export const sendSignCode = (data)=>request.get(`/order/inform/sendSignCode/${data.phone}/${data.id}`)
//告知函确认
export const sureNotify = (data)=>request.get(`/order/inform/sure/${data.id}/${data.signCode}/${data.phone}`)

